import script from "./Merged.vue?vue&type=script&setup=true&lang=ts"
export * from "./Merged.vue?vue&type=script&setup=true&lang=ts"

import "./Merged.vue?vue&type=style&index=0&id=683fa68a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\konstantinos\\Desktop\\vouliagmeni\\threesixty_vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-683fa68a"]])

export default __exports__